import { createStore } from "easy-peasy";
import AppStore from "./AppStore";
import AuthStore from "./AuthStore";

export default createStore({
  auth: AuthStore,
  app: AppStore,
});
